<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="400"
  >
    <v-card style="position: relative">
      <v-overlay
        absolute
        :value="submitting"
        class="text-center"
      >
        <v-progress-circular
          indeterminate
          :size="50"
          color="primary"
        />
        <p class="text-overline white--text mt-4">
          Propagating changes. May take a while...
        </p>
      </v-overlay>
      <v-card-title class="text-h5">
        Docketwise Integration
      </v-card-title>
      <v-card-text>Would you like to create a contact from <b>({{ title }})</b>?</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="green darken-1"
          text
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="onSubmit"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PEPartyDocketwiseCreateDialog',

  props: {
    onSubmit: {
      type: Function,
      required: true,
    },

    submitting: {
      type: Boolean,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    value: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    dialog: {
      get () { return this.value },

      set (val) {
        this.$emit('input', val)
      },
    },
  },
}
</script>
